'use strict';

angular.module('amexReconciliationApp').directive('confirmNavigation', function($window) {
  return {
    require: '^form',
    scope: {
      confirmNavigationMessage: '@'
    },
    link: function($scope, element, attrs, form) {
      $scope.$on('$stateChangeStart', function(event) {
        if(form.$dirty) {
          if(!$window.confirm(attrs.confirmNavigationMessage)) {
            event.preventDefault();
          }
          else {
            form.$setPristine();
          }
        }
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/confirmNavigation.js
// module id = 518
// module chunks = 0